import AddCapability from '@codeDelivery/views/AddCapability/AddCapability';

export default AddCapability;
